import React from 'react';
import { Root, WrapperRootProps } from './Wrapper.styles';

export interface WrapperProps extends WrapperRootProps {
  children?: React.ReactNode;
}

export const Wrapper = (props: WrapperProps) => {
  const { children, ...rootProps } = props;
  return <Root {...rootProps}>{children}</Root>;
};
